import { Box, Fade, IconButton, Typography } from '@mui/material'
import _ from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

/** COMPONENT */
import InputTextField from 'component/Input/InputTextField'
import TreatmentList, { CustomInputCheckbox } from 'features/finance/payment/component/popupPayment/TreatmentList'

/** CONSTANTS */
import { PaymentInterface } from 'api/counter/payment/payment-interface'
import { colors } from 'constants/theme'

import {
  promotion,
  setPaymentChannelByKey,
  setPromotion,
  setSummeryByKey,
  setSummerySubByKey,
  setSummerySubTreatmentRightByKey,
  setSummeryTreatmentRightByKey,
  setVoucher,
  summery,
  summerySub,
  summeryTreatmentRight,
  valPayment,
  voucher
} from 'app/slice/payment.slice'

import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { swalWarning } from 'component/Alert/Swal'
import { notiError } from 'component/notifications/notifications'
import { icons } from 'constants/images'
import * as UseStyled from 'features/finance/payment/component/popupPayment/UseStyledFormPayment'

const initErrMsg = { OVER_MAX_PAID: '', OVER_BALANCE_PAID: '' }
interface PrivilegeProps {
  // no?: number
  index?: number
  title?: any
  treatments?: any
  component?: any
  paymentChannelId: number
  patientTreatmentRightId?: number
  treatmentRight?: any
  treatmentRightValue?: any
  type?: 'TreatmentDiscount' | 'OtherDiscount' | 'PaymentChannels' | 'VOUCHER'
  menu?: 'PAYMENT' | 'OVERDUE' | 'RETROSPECTIVE' | 'EDIT_PAYMENT'
  balancePaid?: number
  maxPaid?: number
  treatmentInfo?: string
  discountHasExpired?: boolean
  disableFiled?: boolean
  disableIcon?: boolean
  value?: any
  advance?: boolean
  changePaid?: (val: number) => void
  onCallbackDel?: (id: number) => void
  dataPatientCase?: any

}

export default function PrivilegeList(props: PrivilegeProps) {
  const dispatch = useDispatch()
  const objPayment: PaymentInterface = useSelector(valPayment)
  const valSummery = useSelector(summery)
  const valSummerySub: any = useSelector(summerySub)
  const valSummeryTreatmentRight = useSelector(summeryTreatmentRight)
  const valSummerySubTreatmentRight: any = useSelector((state: any) => state.payment.summerySubTreatmentRight)
  const usePromotion = useSelector(promotion)
  const useVoucher = useSelector(voucher)


  const [expanded, setExpanded] = useState(false)
  const [isDisabled, setIsDisabled]: any = useState({})
  const [isChecked, setIsChecked]: any = useState({})
  const [errMsg, setErrMsg] = useState({ ...initErrMsg })
  const [valSum, setValSum]: any = useState(0)
  const [treatmentPrice, setTreatmentPrice]: any = useState(0)


  const priceOutStanding = props?.treatments?.outStandingPayment?.overdueTotal || 0

  useEffect(() => {
    if (props.patientTreatmentRightId && props.paymentChannelId !== 7 && (props.paymentChannelId !== 8 && props?.menu !== "EDIT_PAYMENT")) {
      dispatch(setSummeryTreatmentRightByKey({ key: props.paymentChannelId, patientTreatmentRightId: props.patientTreatmentRightId, value: { isCheck: false, value: 0, isDisabled: true } }))
      isDisabled[props.patientTreatmentRightId] = true
      isChecked[props.patientTreatmentRightId] = false
    }
    // dispatch(setPromotion(undefined))
  }, [props.paymentChannelId, props.patientTreatmentRightId])


  useEffect(() => {

    if (props.paymentChannelId === 5) {
      let newPriceOutStanding = priceOutStanding

      const priceCurrent = 0

      const newOption = props.menu === 'EDIT_PAYMENT' ? [...(props?.treatments?.order?.orderTreatments || []), ...(props?.treatments?.order?.orderProducts || [])] : props.treatments.summeryTreatments
      _.map(newOption, (treatment, index) => {
        let type = ''
        let id = null
        if (treatment.tempOrderTreatmentId || treatment.orderTreatmentId) id = treatment.tempOrderTreatmentId || treatment.orderTreatmentId
        else if (treatment.tempOrderProductId || treatment.orderProductId) id = treatment.tempOrderProductId || treatment.orderProductId
        else id = parseInt(index) + 1

        const isTreatment = treatment.tempOrderTreatmentId || treatment.orderTreatmentId || treatment.operativeId ? true : false
        if (props.menu === 'RETROSPECTIVE') type = isTreatment ? 'ORDER_TREATMENT' : 'ORDER_PRODUCT'
        else if (props.menu === 'EDIT_PAYMENT') type = isTreatment ? 'ORDER_TREATMENT' : 'ORDER_PRODUCT'
        else if (props.menu === 'OVERDUE') type = isTreatment ? 'ORDER_TREATMENT' : 'ORDER_PRODUCT'
        else type = isTreatment ? 'TEMP_ORDER_TREATMENT' : 'TEMP_ORDER_PRODUCT'

        const newPriceOut = treatment.total < newPriceOutStanding ? treatment.total : newPriceOutStanding
        const newTotal = (treatment.total - newPriceOutStanding) <= 0 ? 0 : treatment.total - newPriceOutStanding
        newPriceOutStanding = (treatment.total - newPriceOutStanding) <= 0 ? newPriceOutStanding - treatment.total : 0

        const paid: number = handleCheckPromotinoSalePrice(newOption, 'filter')
        const sumPaid = paid - priceCurrent
        const val: any = 0
        const balance = newTotal
        const valOther = handleValOther(id, 7,)



        if (props.patientTreatmentRightId)
          dispatch(
            setSummerySubTreatmentRightByKey({
              key: props.paymentChannelId,
              keySub: index,
              patientTreatmentRightId: props.patientTreatmentRightId,
              value: {
                isCheck: false,
                value: val,
                treatmentPrice: newTotal,
                paidBalance: newTotal,
                paymentOut: newPriceOut,
                type: type,
                id: id,
                refItemId: id,
                isDisabled: true
              }
            })
          )
      })
    }
  }, [props.paymentChannelId, props?.treatments?.order, props.treatments.summeryTreatments])


  useEffect(() => {


    if (props.menu === 'EDIT_PAYMENT' && (props.paymentChannelId === 8 || props.paymentChannelId === 7)) {
      return
    }

    if ((props.paymentChannelId === 7 || props.paymentChannelId === 8) && props.patientTreatmentRightId) {

      const newKey = props.paymentChannelId === 8 ? 'promotion' : 'voucher'
      const treatmentRightValue = props?.treatmentRight?.[`${newKey}PriceUnit`] === 'PERCENT' ? ((objPayment?.totalPrice + priceOutStanding + onCalWidthOutProNVoucher()) * (props.treatmentRight?.[`${newKey}Price`] || 0)) / 100 : props.treatmentRight?.[`${newKey}Price`]
      if (props.paymentChannelId === 7) {
        dispatch(setSummeryTreatmentRightByKey({ key: props.paymentChannelId, patientTreatmentRightId: props.patientTreatmentRightId, value: { isCheck: true, value: treatmentRightValue, isDisabled: true } }))
      }
      const checkUseVoucher: any = {}
      const voucherPriceUse: any = {}

      const newOption = props.menu === 'EDIT_PAYMENT' ? [...(props?.treatments?.order?.orderTreatments || []), ...(props?.treatments?.order?.orderProducts || [])] : props.treatments.summeryTreatments

      let treatmentRight: any = (props.paymentChannelId === 7 && useVoucher?.length ? useVoucher : (props.paymentChannelId === 8 && usePromotion?.length ? usePromotion : props.treatmentRight))
      let voucherPriceUnit: string, voucherPrice: number, voucherPriceType: string, voucherUsage: string, items: any
      let itemsUsed: any[] = []


      if (((props.paymentChannelId === 7 && props?.patientTreatmentRightId === treatmentRight?.voucherListId) || (props.paymentChannelId === 8 && props.patientTreatmentRightId === usePromotion?.promotionBranchId)) && props.patientTreatmentRightId && treatmentRight) {
        voucherPriceUnit = treatmentRight?.voucherPriceUnit || treatmentRight?.promotionPriceUnit
        voucherPrice = treatmentRight?.voucherPrice || treatmentRight?.promotionPrice
        voucherPriceType = treatmentRight?.voucherPriceType || treatmentRight?.promotionPriceType
        voucherUsage = treatmentRight?.voucherUsage || treatmentRight?.promotionUsage
        items = props.paymentChannelId === 7 ? treatmentRight?.items : treatmentRight?.items
        itemsUsed = treatmentRight?.items ? { ...treatmentRight?.items } : []

        const checkCanUseTr = _.map(items, (item) => {
          const usableVoucher = newOption.find((tr: any) => {
            const itemType = tr.operativeId ? "OPERATIVE" : tr.group
            const itemId = tr.operativeId || tr.itemId
            const qty = tr.qty
            const price = tr.price
            return Number(item?.itemId) === Number(itemId) && item.itemType === itemType && Number(item.qty) === Number(qty)
          })
          return usableVoucher
        })
        if (voucherPriceUse[props.patientTreatmentRightId] === undefined) voucherPriceUse[props.patientTreatmentRightId] = voucherPrice

        if (voucherPriceType === 'SALEPRICE') {
          voucherPriceUse[props.patientTreatmentRightId] = _.sumBy(checkCanUseTr, 'total') - (voucherPrice || 0)
        } else {
          if (checkCanUseTr.length) {

            if (voucherPriceUnit === 'PERCENT') {
              voucherPriceUse[props.patientTreatmentRightId] = (_.sumBy(checkCanUseTr, 'total') * (voucherPrice || 0)) / 100
            } else {
              voucherPriceUse[props.patientTreatmentRightId] = voucherPrice || 0
            }
          } else {


            if (voucherPriceUnit === 'PERCENT') {
              voucherPriceUse[props.patientTreatmentRightId] = ((objPayment?.subTotal + priceOutStanding + onCalWidthOutProNVoucher()) * (voucherPrice || 0)) / 100
            } else {
              voucherPriceUse[props.patientTreatmentRightId] = voucherPrice || 0
            }
          }
        }
      }
      let voucherBalance = voucherPriceUse[props.patientTreatmentRightId]

      _.map(newOption, async (treatment, index) => {
        const sub = valSummerySub[props.paymentChannelId][index]

        let val: any = 0
        const balance = isNaN(sub.paidBalance) ? sub.treatmentPrice : sub.paidBalance
        if (props.patientTreatmentRightId) {
          let isCheck = false
          let isDisabled = false
          if (((props.paymentChannelId === 7 && props.patientTreatmentRightId === treatmentRight?.voucherListId) || (props.paymentChannelId === 8 && props.patientTreatmentRightId === usePromotion?.promotionBranchId)) && treatmentRight) {
            if (items && checkUseVoucher[index] === undefined) {

              const usableVoucher = await _.findIndex(items, (item: any) => {
                const itemType = treatment.operativeId ? "OPERATIVE" : treatment.group
                const itemId = treatment.operativeId || treatment.itemId
                const qty = treatment.qty
                return Number(item?.itemId) === Number(itemId) && item.itemType === itemType && Number(item.qty) === Number(qty)
              })
              if (treatmentRight && treatmentRight.items && usableVoucher !== -1) {
                isCheck = true
                if (checkUseVoucher[index] === undefined) checkUseVoucher[index] = true


                let item = items[usableVoucher]
                item = { ...item, type: sub?.type, id: sub?.id }


                if (voucherBalance - balance <= 0) {
                  val = voucherBalance
                  voucherPriceUse[props.patientTreatmentRightId] = 0
                } else if (voucherBalance - balance > 0) {
                  val = balance
                  voucherPriceUse[props.patientTreatmentRightId] = voucherBalance - balance
                }

                itemsUsed[usableVoucher] = item
              }
            } else {
              if (voucherBalance - balance <= 0) {
                val = voucherBalance
                voucherPriceUse[props.patientTreatmentRightId] = 0
              } else if (voucherBalance - balance > 0) {
                val = balance
                voucherPriceUse[props.patientTreatmentRightId] = voucherBalance - balance
              }
              if (val > 0) isCheck = true
            }
            voucherBalance -= val

            isDisabled = true
          }
          dispatch(setSummerySubByKey({
            key: props.paymentChannelId, keySub: index, value: {
              ...sub,
              isCheck: isCheck,
              value: val,
              paidBalance: (isNaN(sub.paidBalance) ? sub.treatmentPrice : sub.paidBalance) - val,
              isDisabled: isDisabled
            }
          }))

          dispatch(
            setSummerySubTreatmentRightByKey({
              key: props.paymentChannelId,
              keySub: index,
              patientTreatmentRightId: props.patientTreatmentRightId,
              value: {
                ...sub,
                paidBalance: (isNaN(sub.paidBalance) ? sub.treatmentPrice : sub.paidBalance) - val,
                isCheck: isCheck,
                value: val,
                isDisabled: isDisabled
              }
            })
          )
        }
      })


      if (itemsUsed.length > 0) treatmentRight = { ...treatmentRight, itemsUsed: itemsUsed }
      if (props.paymentChannelId === 7 && treatmentRight) {
        dispatch(setPaymentChannelByKey({ key: 7, value: true }))
        dispatch(setVoucher(treatmentRight))
      }

    }
  }, [props.patientTreatmentRightId, useVoucher?.voucherListId, props.paymentChannelId, props?.treatments?.order, props.treatments.summeryTreatments])




  const clearErrMsg = () => setErrMsg({ ...initErrMsg })

  const summaryOriginalValue = () => {
    const paymentChannel = props.treatments.orderPaymentChannel || 0
    const paymentChannelAdvance = props.treatments.orderPaymentChannelAdvance || 0
    const paymentChannelTreatmentRight = props.treatments.orderPaymentChannelTreatmentRight || 0
    const sum = paymentChannel + paymentChannelAdvance + paymentChannelTreatmentRight
    return sum
  }

  const handleChangValue = (valuePayment: string) => {
    clearErrMsg()


    const rawValuePM = valuePayment === '' ? 0 : String(valuePayment).replace(/[^0-9.]/g, '')
    let valuePM = rawValuePM ? parseFloat(rawValuePM) : 0
    if (props.paymentChannelId === 6) {
      dispatch(setPaymentChannelByKey({ key: 6, value: valuePM > 0 ? true : false }))
    }
    if (props.paymentChannelId === 6) {
      if (props?.balancePaid && props?.maxPaid) {
        valuePM = valuePM > props?.balancePaid ? props?.maxPaid : valuePM
      } else {
        valuePM = 0
      }
    }

    if (props.menu === 'EDIT_PAYMENT') {
      valuePM = Math.min(valuePM, summaryOriginalValue() + props.treatments.overdue)
    }
    const selectSumSub: any[] = valSummerySub[props.paymentChannelId]
    console.log('valuePayment', valuePayment, props.paymentChannelId);

    let paid: number = valuePM

    let overPaid: any = 0
    for (const key in selectSumSub) {
      if (Object.prototype.hasOwnProperty.call(selectSumSub, key)) {
        const sub = selectSumSub[key]
        let val: any = 0

        const balance = sub.paidBalance
        const value = sub.value

        if (balance + value <= paid) {
          val = balance + value
          paid -= balance + value
        } else {
          val = paid
          paid -= paid
        }
        if (props.paymentChannelId === 1) {
          overPaid = val
        }

        dispatch(
          setSummerySubByKey({
            key: props.paymentChannelId,
            keySub: key,
            value: {
              ...sub,
              value: val,
              isCheck: val > 0 ? true : false,
              isDisabled: val > 0 ? false : true
            }
          })
        )
      }
    }

    const sumPaidBalance = _.sumBy(selectSumSub, 'paidBalance')
    const sumValue = _.sumBy(selectSumSub, 'value')
    const sumTreatmentPrice = _.sumBy(selectSumSub, 'treatmentPrice')


    {
      props.advance
        ? dispatch(setSummeryByKey({ key: props.paymentChannelId, value: valuePM }))
        :
        dispatch(setSummeryByKey({ key: props.paymentChannelId, value: paid >= 1000 ? calCashLimit(sumValue + sumPaidBalance, 1000, sumTreatmentPrice) : valuePM }))
    }

    props?.changePaid && props?.changePaid(valuePM)
  }

  const calCashLimit = (number: number, near: number, sumTreatmentPrice: number) => {
    if (number > sumTreatmentPrice && number <= sumTreatmentPrice + 1000) return number
    else return parseInt(String(number / near)) * near + near
  }

  const handleValOther = (id: number, newIndex: number) => {
    let total = 0
    Object.values(valSummerySub).forEach((item: any, index: number) => {
      if (newIndex !== index) {
        item.map((item_2: any) => {
          if (item_2.isCheck && item_2.id === id) {
            total += item_2.value
          }
        })
      }
    })
    const newTreatmentRight = valSummerySubTreatmentRight[props.paymentChannelId] || []
    newTreatmentRight.forEach((item: any, index: number) => {
      if (index !== props.patientTreatmentRightId) {
        newTreatmentRight[index].forEach((item_2: any) => {
          if (item_2.isCheck && item_2.id === id) {
            total += item_2.value
          }
        })
      }
    })
    return total
  }

  const handleChangValueTreatmentRight = (valuePaymentTreatmentRight: string) => {
    const rawValueTR = valuePaymentTreatmentRight === '' ? 0 : String(valuePaymentTreatmentRight).replace(/[^0-9.]/g, '')
    let valueTR = rawValueTR ? parseFloat(rawValueTR) : 0
    const paymentChannelId = props.paymentChannelId
    const patientTreatmentRightId = props.patientTreatmentRightId
    if (patientTreatmentRightId) {
      const treatmentRight = props.treatmentRight
      let res = valSummeryTreatmentRight[paymentChannelId]
      if (res) res = res[patientTreatmentRightId]
      if (res.isCheck) {
        if (treatmentRight.isDivide) {
          const sumTreatmentRight = _.sumBy(valSummerySubTreatmentRight[paymentChannelId][patientTreatmentRightId], 'value')
          if (sumTreatmentRight > treatmentRight.balance || valueTR > treatmentRight.balance) return swalWarning(`ยอดเงินการใช้สิทธิ ${treatmentRight.treatmentRightName} ต้องไม่เกิน ${treatmentRight.balance} บาท`)
        }
      } else {
        valueTR = 0
      }
      const selectSumSub: any[] = valSummerySub[props.paymentChannelId]
      const selectSumTrSub: any[] = valSummerySubTreatmentRight[paymentChannelId][patientTreatmentRightId]

      let paid: number = valueTR
      for (const key in selectSumTrSub) {
        if (Object.prototype.hasOwnProperty.call(selectSumTrSub, key)) {
          const sub = selectSumSub[key]
          let val: any = 0

          const balance = sub.treatmentPrice
          const valOther = handleValOther(sub.id, props.paymentChannelId)

          // if (sub.paidBalance > 0) {
          if (valOther + paid > balance) {
            val = balance - valOther
            paid -= balance - valOther
          } else {
            val = paid
            paid -= paid
          }
          // }
          dispatch(
            setSummerySubTreatmentRightByKey({
              key: paymentChannelId,
              keySub: key,
              patientTreatmentRightId: patientTreatmentRightId,
              value: {
                ...sub,
                value: val,
                isCheck: true,
                isDisabled: false
              }
            })
          )
        }
      }

      dispatch(setSummeryTreatmentRightByKey({ key: paymentChannelId, patientTreatmentRightId: patientTreatmentRightId, value: { isCheck: res.isCheck, value: valueTR, isDisabled: res.isDisabled } }))
    }
    props?.changePaid && props?.changePaid(valueTR)
  }


  const hadleCheckPaymentChanelFive = (check: boolean, patientTreatmentRightId: number) => {
    if (check) {
      return true
    } else {
      const valSummery = valSummeryTreatmentRight[props.paymentChannelId]?.filter((item: any, index: number) => index !== patientTreatmentRightId)
      const isCheck = valSummery?.some((item: any) => item.isCheck)
      return isCheck
    }
  }

  const handleCheckPromotinoSalePrice = (sub: any, key: 'some' | 'filter') => {
    // const itemList = props.treatmentRight?.itemName.split(", ")
    const itemList = props.treatmentRight?.items?.length ? props.treatmentRight?.items.map((item: any) => Number(item?.itemId)) : []
    sub = (!sub?.id) ? { id: sub?.tempOrderTreatmentId || sub?.tempOrderProductId } : sub
    const check = props?.treatments?.summeryTreatments?.[key]((item: any) =>
      (sub?.id === item?.tempOrderProductId || sub?.id === item?.tempOrderTreatmentId) &&
      itemList.includes(item?.operativeId || item?.itemId) &&
      (!item?.promotion?.length || item?.promotion?.length && item?.promotion?.some((info: any) => info?.promotionType !== "EXTRA"))
    )
    if (key === 'filter') {
      const totalTreatment = check?.reduce((accumulator: any, item: any) => accumulator + item?.total, 0,);
      return totalTreatment || 0
    }
    return check
  }

  const onCalWidthOutProNVoucher = () => {
    const discountPromotion = _.sumBy(valSummeryTreatmentRight[8], (o: any) => { return o?.isCheck ? Number(o.value) : 0 }) || 0
    const discountVoucher = _.sumBy(valSummeryTreatmentRight[7], (o: any) => { return o?.isCheck ? Number(o.value) : 0 }) || 0
    return discountPromotion + discountVoucher
  }

  const handleCheckBox = (treatmentRight: any, check?: boolean | undefined, index?: number | undefined) => {
    if (props.paymentChannelId && index) {
      const foreignKey = props.paymentChannelId
      const patientTreatmentRightId = index

      let sub = valSummeryTreatmentRight[foreignKey]
      let treatmentRightValue = 0
      if (sub) sub = sub[patientTreatmentRightId]
      let isCheck = check !== undefined ? check : sub.isCheck ? false : true
      let disabled = sub.isCheck ? false : true
      if (isCheck) setExpanded(true)
      else setExpanded(false)
      dispatch(setPaymentChannelByKey({ key: props.paymentChannelId, value: hadleCheckPaymentChanelFive(isCheck, patientTreatmentRightId) }))

      let checkCanUseTr = []
      const { voucherPriceUnit, voucherPrice, voucherPriceType, voucherUsage, items } = treatmentRight || props.treatmentRight
      const { promotionPriceUnit, promotionPrice, promotionPriceType, promotionUsage, items: itemsPro } = treatmentRight || props.treatmentRight

      if (treatmentRight.isDivide === '1') {
        if (isCheck) disabled = false
        else disabled = true
      } else if (treatmentRight?.promotionBranchId && treatmentRight?.promotionBranchId === index) {
        const promotionPriceUse: any = {}
        const checkUsePromotion: any = {}

        const treatments = props?.treatments?.summeryTreatments
        const itemsUsed: any[] = itemsPro ? { ...itemsPro } : []

        /** 
         * !! กรณีที่ผูกกับรายการ
         * ต้องเช็ค ว่ามีรายการที่เข้าเงื่อนไขมั้ย 
         * voucherPriceType DISCOUNT || SALEPRICE (มูลค่าลด || ราคาหลังลด)
         */
        if (itemsPro && itemsPro.length) {
          checkCanUseTr = _.map(itemsPro, (item) => {
            const usableVoucher = treatments.find((tr: any) => {
              const itemType = tr.operativeId ? "OPERATIVE" : tr.group
              const itemId = tr.operativeId || tr.itemId
              const qty = tr.qty
              const price = tr.price
              return Number(item?.itemId) === Number(itemId) && item.itemType === itemType && Number(item.qty) === Number(qty)
            })
            return usableVoucher
          })

          if (checkCanUseTr.length !== itemsPro.length) {
            notiError('รายการไม่ครบตามเงื่อนไข')
            isCheck = false
            return false
          }

          if (treatmentRight.minimum > _.sumBy(checkCanUseTr, 'total')) {
            notiError(`ราคารวมขั้นต่ำ ${treatmentRight.minimum} บาท 
              รายการ ${_.map(checkCanUseTr, (item) => {
              return (item.operativeName || item.itemName)
            })}`)
            isCheck = false
            return false
          }
        }


        if (promotionPriceUse[treatmentRight?.promotionBranchId] === undefined) promotionPriceUse[treatmentRight?.promotionBranchId] = promotionPrice

        if (promotionPriceType === 'SALEPRICE') {
          promotionPriceUse[treatmentRight?.promotionBranchId] = _.sumBy(checkCanUseTr, 'total') - (promotionPrice || 0)
        } else {
          if (checkCanUseTr.length) {
            if (promotionPriceUnit === 'PERCENT') {
              promotionPriceUse[treatmentRight?.promotionBranchId] = (_.sumBy(checkCanUseTr, 'total') * (promotionPrice || 0)) / 100
            } else {
              promotionPriceUse[treatmentRight?.promotionBranchId] = promotionPrice || 0
            }
          } else {


            if (promotionPriceUnit === 'PERCENT') {
              promotionPriceUse[treatmentRight?.promotionBranchId] = ((objPayment?.subTotal + priceOutStanding + onCalWidthOutProNVoucher()) * (promotionPrice || 0)) / 100
            } else {
              promotionPriceUse[treatmentRight?.promotionBranchId] = promotionPrice || 0
            }
          }
        }

        treatmentRightValue = promotionPriceUse[treatmentRight?.promotionBranchId]

        disabled = true

        _.map(treatments, async (treatment, index) => {
          // const sub = valSummerySub[props.paymentChannelId][index]

          const sub: any = valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId][index]

          let val: any = 0
          const balance = sub.paidBalance
          let isCheck = false
          let isDisabled = false
          const voucherBalance = promotionPriceUse[treatmentRight?.promotionBranchId]
          if (items && checkUsePromotion[index] === undefined) {

            const usableVoucher = await _.findIndex(items, (item: any) => {
              const itemType = treatment.operativeId ? "OPERATIVE" : treatment.group
              const itemId = treatment.operativeId || treatment.itemId
              const qty = treatment.qty
              return Number(item?.itemId) === Number(itemId) && item.itemType === itemType && Number(item.qty) === Number(qty)
            })

            if (treatmentRight && treatmentRight.items && usableVoucher !== -1) {
              isCheck = true
              if (checkUsePromotion[index] === undefined) checkUsePromotion[index] = true


              let item = items[usableVoucher]
              item = { ...item, type: sub?.type, id: sub?.id }
              if (voucherBalance - balance <= 0) {
                val = voucherBalance
                promotionPriceUse[treatmentRight?.promotionBranchId] = 0
              } else if (voucherBalance - balance > 0) {
                val = balance
                promotionPriceUse[treatmentRight?.promotionBranchId] = voucherBalance - balance
              }

              itemsUsed[usableVoucher] = item
            }
          } else {
            if (voucherBalance - balance <= 0) {
              val = voucherBalance
              promotionPriceUse[treatmentRight?.promotionBranchId] = 0
            } else if (voucherBalance - balance > 0) {
              val = balance
              promotionPriceUse[treatmentRight?.promotionBranchId] = voucherBalance - balance
            }
            if (val > 0) isCheck = true
          }
          isDisabled = true
          dispatch(setSummerySubByKey({
            key: props.paymentChannelId, keySub: index, value: {
              ...sub,
              isCheck: isCheck,
              value: val,
              paidBalance: sub.paidBalance - val,
              isDisabled: isDisabled
            }
          }))

          dispatch(
            setSummerySubTreatmentRightByKey({
              key: props.paymentChannelId,
              keySub: index,
              patientTreatmentRightId: props.patientTreatmentRightId,
              value: {
                ...sub,
                paidBalance: sub.paidBalance - val,
                isCheck: isCheck,
                value: val,
                isDisabled: isDisabled
              }
            })
          )
        })


        if (itemsUsed.length > 0) treatmentRight = { ...treatmentRight, itemsUsed: itemsUsed }

        dispatch(setPromotion(treatmentRight))
        dispatch(setPaymentChannelByKey({ key: 8, value: true }))
      } else if (check && treatmentRight?.voucherListId && treatmentRight?.voucherListId === index) {
        const treatments = props?.treatments?.summeryTreatments

        const voucherPriceUse: any = {}
        const checkUsevoucher: any = {}

        const itemsUsed: any[] = items ? { ...items } : []

        /** 
         * !! กรณีที่ผูกกับรายการ
         * ต้องเช็ค ว่ามีรายการที่เข้าเงื่อนไขมั้ย 
         * voucherPriceType DISCOUNT || SALEPRICE (มูลค่าลด || ราคาหลังลด)
         */
        if (items && items.length) {
          checkCanUseTr = _.map(items, (item) => {
            const usableVoucher = treatments.find((tr: any) => {
              const itemType = tr.operativeId ? "OPERATIVE" : tr.group
              const itemId = tr.operativeId || tr.itemId
              const qty = tr.qty
              const price = tr.price
              return Number(item?.itemId) === Number(itemId) && item.itemType === itemType && Number(item.qty) === Number(qty)
            })
            return usableVoucher
          })

          if (checkCanUseTr.length !== items.length) {
            notiError('รายการไม่ครบตามเงื่อนไข')
            isCheck = false
            return false
          }

          if (treatmentRight.minimum > _.sumBy(checkCanUseTr, 'total')) {
            notiError(`ราคารวมขั้นต่ำ ${treatmentRight.minimum} บาท 
              รายการ ${_.map(checkCanUseTr, (item) => {
              return (item.operativeName || item.itemName)
            })}`)
            isCheck = false
            return false
          }
        }


        if (voucherPriceUse[treatmentRight?.voucherBranchId] === undefined) voucherPriceUse[treatmentRight?.voucherBranchId] = voucherPrice

        if (voucherPriceType === 'SALEPRICE') {
          voucherPriceUse[treatmentRight?.voucherBranchId] = _.sumBy(checkCanUseTr, 'total') - (voucherPrice || 0)
        } else {
          if (checkCanUseTr.length) {
            if (voucherPriceUnit === 'PERCENT') {
              voucherPriceUse[treatmentRight?.voucherBranchId] = (_.sumBy(checkCanUseTr, 'total') * (voucherPrice || 0)) / 100
            } else {
              voucherPriceUse[treatmentRight?.voucherBranchId] = voucherPrice || 0
            }
          } else {


            if (voucherPriceUnit === 'PERCENT') {
              voucherPriceUse[treatmentRight?.voucherBranchId] = ((objPayment?.subTotal + priceOutStanding + onCalWidthOutProNVoucher()) * (voucherPrice || 0)) / 100
            } else {
              voucherPriceUse[treatmentRight?.voucherBranchId] = voucherPrice || 0
            }
          }
        }
        treatmentRightValue = voucherPriceUse[treatmentRight?.voucherBranchId]

        disabled = true

        _.map(treatments, async (treatment, index) => {
          const sub = valSummerySub[props.paymentChannelId][index]
          let val: any = 0
          const balance = sub.paidBalance
          let isCheck = false
          let isDisabled = false
          const voucherBalance = voucherPriceUse[treatmentRight?.voucherBranchId]
          if (items && checkUsevoucher[index] === undefined) {

            const usableVoucher = await _.findIndex(items, (item: any) => {
              const itemType = treatment.operativeId ? "OPERATIVE" : treatment.group
              const itemId = treatment.operativeId || treatment.itemId
              const qty = treatment.qty
              return Number(item?.itemId) === Number(itemId) && item.itemType === itemType && Number(item.qty) === Number(qty)
            })

            if (treatmentRight && treatmentRight.items && usableVoucher !== -1) {
              isCheck = true
              if (checkUsevoucher[index] === undefined) checkUsevoucher[index] = true


              let item = items[usableVoucher]
              item = { ...item, type: sub?.type, id: sub?.id }
              if (voucherBalance - balance <= 0) {
                val = voucherBalance
                voucherPriceUse[treatmentRight?.voucherBranchId] = 0
              } else if (voucherBalance - balance > 0) {
                val = balance
                voucherPriceUse[treatmentRight?.voucherBranchId] = voucherBalance - balance
              }

              itemsUsed[usableVoucher] = item
            }
          } else {
            if (voucherBalance - balance <= 0) {
              val = voucherBalance
              voucherPriceUse[treatmentRight?.voucherBranchId] = 0
            } else if (voucherBalance - balance > 0) {
              val = balance
              voucherPriceUse[treatmentRight?.voucherBranchId] = voucherBalance - balance
            }
            if (val > 0) isCheck = true
          }
          isDisabled = true
          dispatch(setSummerySubByKey({
            key: props.paymentChannelId, keySub: index, value: {
              ...sub,
              isCheck: isCheck,
              value: val,
              paidBalance: sub.paidBalance - val,
              isDisabled: isDisabled
            }
          }))

          dispatch(
            setSummerySubTreatmentRightByKey({
              key: props.paymentChannelId,
              keySub: index,
              patientTreatmentRightId: props.patientTreatmentRightId,
              value: {
                ...sub,
                paidBalance: sub.paidBalance - val,
                isCheck: isCheck,
                value: val,
                isDisabled: isDisabled
              }
            })
          )
        })
      } else {
        if (treatmentRight?.treatmentRightId) {
          const channel: any = valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId]

          // const treatments = props?.treatments?.summeryTreatments
          // const treatmentRightUse: any = {}
          // const checkUsevoucher: any = {}

          // if (treatmentRightUse[treatmentRight?.treatmentRightId] === undefined) treatmentRightUse[treatmentRight?.treatmentRightId] = 0

          // if (treatmentRight.unit === UNIT_PER_BAHT.BAHT)
          //   treatmentRightUse[treatmentRight?.treatmentRightId] = treatmentRight.price
          // else {
          //   const total = _.sumBy(treatments, (treatment: any) => {
          //     if (treatment.installment) {
          //       const pendingInstallment = _.find(treatment.installment.installmentList, { status: "PENDING" });
          //       if (pendingInstallment) {
          //         return pendingInstallment.price;
          //       }
          //     }
          //     return treatment.total;
          //   });
          //   treatmentRightUse[treatmentRight?.treatmentRightId] = total * (treatmentRight.price / 100)
          // }
          // _.map(treatments, async (treatment, index) => {
          //   const sub = valSummerySub[props.paymentChannelId][index]

          //   const refund = channel[index]

          //   let val: any = 0
          //   const balance = sub.paidBalance
          //   const isDisabled = disabled
          //   const treatmentRightBalance = treatmentRightUse[treatmentRight.treatmentRightId]
          //   if (isCheck) {
          //     if (treatmentRightBalance - balance <= 0) {
          //       val = treatmentRightBalance
          //       treatmentRightUse[treatmentRight.treatmentRightId] = 0
          //     } else if (treatmentRightBalance - balance > 0) {
          //       val = balance
          //       treatmentRightUse[treatmentRight.treatmentRightId] = treatmentRightBalance - balance
          //     }
          //   }

          //   // if (val > 0) isCheck = true
          //   dispatch(setSummerySubByKey({
          //     key: props.paymentChannelId, keySub: index, value: {
          //       ...sub,
          //       isCheck: isCheck,
          //       value: val,
          //       paidBalance: isCheck ? sub.paidBalance - val : sub.paidBalance + refund.value,
          //       isDisabled: isDisabled
          //     }
          //   }))

          //   dispatch(
          //     setSummerySubTreatmentRightByKey({
          //       key: props.paymentChannelId,
          //       keySub: index,
          //       patientTreatmentRightId: props.patientTreatmentRightId,
          //       value: {
          //         ...sub,
          //         paidBalance: isCheck ? sub.paidBalance - val : sub.paidBalance + refund.value,
          //         isCheck: isCheck,
          //         value: val,
          //         isDisabled: isDisabled
          //       }
          //     })
          //   )
          // })

          disabled = true
        }
      }


      dispatch(setSummeryTreatmentRightByKey({ key: foreignKey, patientTreatmentRightId: patientTreatmentRightId, value: { isCheck: isCheck, value: isCheck ? treatmentRightValue : 0, isDisabled: disabled } }))
      isChecked[patientTreatmentRightId] = isCheck
      isDisabled[patientTreatmentRightId] = disabled

      if (!isChecked[patientTreatmentRightId] && foreignKey === 8) {
        dispatch(setPromotion({}))
      }


      if (valSummerySubTreatmentRight[foreignKey] && valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId]) {
        if (valSummeryTreatmentRight && valSummeryTreatmentRight[foreignKey] && valSummeryTreatmentRight[foreignKey][patientTreatmentRightId] && !isChecked[patientTreatmentRightId]) {
          for (const index in valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId]) {
            if (Object.prototype.hasOwnProperty.call(valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId], index)) {
              const treatmentRightByKey = valSummerySubTreatmentRight[foreignKey][patientTreatmentRightId][index]
              dispatch(
                setSummerySubTreatmentRightByKey({
                  key: foreignKey,
                  keySub: index,
                  patientTreatmentRightId: patientTreatmentRightId,
                  value: {
                    ...treatmentRightByKey,
                    isCheck: false,
                    value: foreignKey === 5 ? 0 : sub.value,
                    treatmentPrice: treatmentRightByKey.treatmentPrice,
                    isDisabled: true,
                    paidBalance: foreignKey === 7 ? sub.paidBalance + sub.value : sub.paidBalance
                  }
                })
              )
            }
          }
        }
      }
    }
  }

  const onRenderCheckBox = (data: any, status: 'isCheck' | 'isDisabled') => {
    const numberOut = [5, 8, 7]
    if (numberOut.includes(props.paymentChannelId)) {
      const newCheck = props.patientTreatmentRightId && valSummeryTreatmentRight[props.paymentChannelId]?.[props.patientTreatmentRightId]
      if (newCheck) {
        return newCheck[status]
      } else {
        return status === 'isDisabled' ? false : true
      }
    } else {
      return data
    }

  }

  const checkStatus = (patientTreatmentRightId?: any) => {
    if (props.paymentChannelId === 5) return false

    const numberOut = [5, 8, 7]
    if (!numberOut.includes(props.paymentChannelId)) return false
    const newTreatmentRight = valSummerySubTreatmentRight[props.paymentChannelId]
    if (((props.paymentChannelId === 8)) && patientTreatmentRightId && newTreatmentRight?.[patientTreatmentRightId]) {
      if (usePromotion?.promotionBranchId && usePromotion?.promotionBranchId !== patientTreatmentRightId) {
        return true
      } else {
        if (props.menu === 'EDIT_PAYMENT') return true
        return false
      }
    }

    let sum = 0
    let treatmentPrice = 0
    _.map(newTreatmentRight, (item: any, index: number) => {
      sum += _.sumBy(item, (o: any) => { return o?.isCheck ? Number(o.value) : 0 })
      treatmentPrice = _.sumBy(item, 'treatmentPrice')
    })
    if (treatmentPrice !== 0) return sum === treatmentPrice
    else return false
  }

  const typeItem = (treatment: any) => {
    let type = ''
    const isTreatment = treatment.tempOrderTreatmentId || treatment.orderTreatmentId || treatment.operativeId ? true : false
    if (props.menu === 'RETROSPECTIVE') type = isTreatment ? 'ORDER_TREATMENT' : 'ORDER_PRODUCT'
    else if (props.menu === 'EDIT_PAYMENT') type = isTreatment ? 'ORDER_TREATMENT' : 'ORDER_PRODUCT'
    else if (props.menu === 'OVERDUE') type = isTreatment ? 'ORDER_TREATMENT' : 'ORDER_PRODUCT'
    else type = isTreatment ? 'TEMP_ORDER_TREATMENT' : 'TEMP_ORDER_PRODUCT'

    return type
  }


  const value = useCallback((index: any = null) => {

    if (props.patientTreatmentRightId && valSummeryTreatmentRight[props.paymentChannelId] && valSummeryTreatmentRight[props.paymentChannelId][props.patientTreatmentRightId]) {
      if (props.paymentChannelId === 8) {
        if (props.patientTreatmentRightId === usePromotion?.promotionBranchId) return _.sumBy(valSummerySubTreatmentRight[props.paymentChannelId][props.patientTreatmentRightId], 'value')
        else if (props.menu === 'EDIT_PAYMENT') return _.sumBy(valSummerySubTreatmentRight[props.paymentChannelId][props.patientTreatmentRightId], 'value')
        else return 0
      }
      if (props.paymentChannelId === 7) {
        if (!props.advance && props.patientTreatmentRightId && valSummerySubTreatmentRight[props.paymentChannelId] && valSummerySubTreatmentRight[props.paymentChannelId][props.patientTreatmentRightId]) return _.sumBy(valSummerySubTreatmentRight[props.paymentChannelId][props.patientTreatmentRightId], 'value')
        else if (props.menu === 'EDIT_PAYMENT') return _.sumBy(valSummerySubTreatmentRight[props.paymentChannelId][props.patientTreatmentRightId], 'value')
        else if (props.advance && props.patientTreatmentRightId && valSummeryTreatmentRight[props.paymentChannelId] && valSummeryTreatmentRight[props.paymentChannelId][props.patientTreatmentRightId]) return valSummeryTreatmentRight[props.paymentChannelId][props.patientTreatmentRightId].value
        else return 0
      }
      return valSummeryTreatmentRight[props.paymentChannelId][props.patientTreatmentRightId].value
    }
    else if (index && valSummerySub[props.paymentChannelId] && valSummerySub[props.paymentChannelId][index]) return valSummerySub[props.paymentChannelId][index]
    else if (valSummery[props.paymentChannelId]) return valSummery[props.paymentChannelId]
    else if (props.treatments?.orderId) {
      if (objPayment.amountReceipt === 0) return objPayment.amountReceipt
      if (objPayment.advance === 0) return objPayment.advance
    }
    else return 0
  }, [valSummeryTreatmentRight, valSummerySubTreatmentRight, valSummerySub, valSummery])

  return (

    <>
      <Box className="d-flex align-items-start mt-3 pr-md-2 pr-xl-3">
        <Box className={`d-flex w-100 ${props.type !== 'TreatmentDiscount' ? 'pt-2' : ''}`} sx={{ paddingLeft: '2px' }}>
          {(props.type === 'TreatmentDiscount' && (
            <CustomInputCheckbox
              label={props.title}
              info={props.treatmentInfo}
              checked={props.patientTreatmentRightId ? onRenderCheckBox(isChecked[props.patientTreatmentRightId], 'isCheck') : props.dataPatientCase?.isNhso === '1' ? true : false}
              onChange={(e) => handleCheckBox(props.treatmentRight, undefined, props.patientTreatmentRightId)}
              disabled={props.discountHasExpired || props.disableFiled || checkStatus(props.paymentChannelId === 8 ? props.patientTreatmentRightId : null)}

            />
          )) || (
              <>

                {(typeof props.title === 'string' && (
                  <Typography className="pr-2" sx={{ fontWeight: 500 }}>
                    {props.title}
                  </Typography>
                )) ||
                  props.title}
              </>
            )}
        </Box>
        <UseStyled.CustomField>
          {props.type === 'TreatmentDiscount' || props.type === 'VOUCHER' ? (
            <>
              <InputTextField
                disabled={(props.disableFiled ? props.disableFiled : ((props.patientTreatmentRightId && props.paymentChannelId !== 5) ? onRenderCheckBox(isDisabled[props.patientTreatmentRightId], 'isDisabled') : true)) || props.discountHasExpired || props.paymentChannelId === 8}
                value={value()}
                type='number'
                financeText
                hideControl
                onchange={(e) => {
                  handleChangValueTreatmentRight(e.target.value)
                }}
                inputTextAlign="right"
              />
            </>
          ) : (
            <>
              <InputTextField
                disabled={props.discountHasExpired || props.disableFiled}
                value={value()}
                type='number'
                financeText
                hideControl
                onchange={(e) => {
                  handleChangValue(e.target.value)
                }}
                helperText={errMsg.OVER_BALANCE_PAID || errMsg.OVER_MAX_PAID || ''}
                inputTextAlign="right"
              />
            </>
          )}
          {props.disableIcon ? <></> :
            <IconButton
              disableRipple
              onClick={() => {
                if (props?.patientTreatmentRightId) {
                  if (onRenderCheckBox(isChecked[props?.patientTreatmentRightId], 'isCheck')) setExpanded(!expanded)
                } else setExpanded(!expanded)
              }}
              className={`icon-expanded ${expanded ? 'isExpanded' : ''} ${props?.patientTreatmentRightId ? (isChecked[props?.patientTreatmentRightId] && '') || 'disabled pe-none' : ''} ${props.discountHasExpired ? 'disabled pe-none' : ''} mt-1`}
            >
              <FontAwesomeIcon icon={faCaretDown} style={{ color: colors.textPrimary, fontSize: 20 }} />
            </IconButton>
          }

        </UseStyled.CustomField>
        {props?.treatmentRight?.voucherListId &&
          <Box>
            <Box
              component={'span'}
              color={colors.statusInactive}
              marginLeft={'8px'}
              onClick={() => {
                if (props.patientTreatmentRightId && props?.onCallbackDel) {
                  handleCheckBox(props.treatmentRight, false, props.patientTreatmentRightId)
                  props.onCallbackDel(props.patientTreatmentRightId)
                }
              }}
              sx={{
                pointerEvents: props?.menu !== 'EDIT_PAYMENT' ? '' : 'none',
                cursor: props?.menu !== 'EDIT_PAYMENT' ? 'pointer' : '',
                filter: props?.menu !== 'EDIT_PAYMENT' ? '' : 'grayscale(1)',
                opacity: props?.menu !== 'EDIT_PAYMENT' ? '' : '0.6',
              }}
            >
              <IconButton >
                <img src={icons.btnTrash} alt="trash" />
              </IconButton>
            </Box>

          </Box>
        }
      </Box>
      {props.dataPatientCase?.isNhso !== '1' &&
        <Fade in={expanded || onRenderCheckBox(isChecked[props?.patientTreatmentRightId || 0], 'isCheck')}>
          <Box className={`${expanded || onRenderCheckBox(isChecked[props?.patientTreatmentRightId || 0], 'isCheck') ? 'd-block' : 'd-none'} pl-4 pr-md-2 pr-xl-3`}>
            <TreatmentList
              patientTreatmentRightId={props.patientTreatmentRightId} treatmentRight={props.treatmentRight} treatments={props.treatments} paymentChannelId={props.paymentChannelId} />
          </Box>
        </Fade>
      }
    </>
  )
}
